import ExamCorpusUpload from '@/components/ExamCorpus/ExamCorpusUpload';

/**
 * Trainer library page. The upload component owns its own layout +
 * identity bar, so this wrapper exists only to keep the router import
 * style consistent with the auth pages.
 */
export default function ExamCorpusPage() {
  return <ExamCorpusUpload />;
}
